export default __webpack_public_path__ + "static/media/cryptopunk-logo.8bee49d5.png";